import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { TypographyComponent } from "@gx1/gx-ui-common";
import { useSignupToken } from "../hooks/use-signup-token.hook";
import GartnerBuySmartLogoSVG from "../../../assets/images/gartner-buy-smart-logo.svg";
import styles from "./expired-token.styles.module.scss";

const ExpiredTokenComponent = () => {
  const { t } = useTranslation();
  const { decodedToken } = useSignupToken();

  return (
    <div className={styles.messageContainer}>
      <div className={styles.imgContainer}>
        <img alt={t("Gartner BuySmart logo")} src={GartnerBuySmartLogoSVG} />
      </div>
      <TypographyComponent styling="h3" color="white" boldness={"semi"} element={"h1"}>
        {t("Your invitation link to join this evaluation has expired.")}
        {` `}
        {t("Please ask the owner to resend your invitation.")}
      </TypographyComponent>
      <div>
        <div className={styles.dividerLine} />
        {decodedToken.initTitle && (
          <Fragment>
            <TypographyComponent rootClassName={styles.title} styling={"p-sm"} element={"span"} color="crystal">
              {t("Evaluation")}
            </TypographyComponent>
            <TypographyComponent rootClassName={styles.titleContent} styling={"p-default"} boldness={"semi"} element={"span"} color="white">
              {decodedToken.initTitle}
            </TypographyComponent>
          </Fragment>
        )}
        {decodedToken.invitedBy && (
          <Fragment>
            <TypographyComponent rootClassName={styles.title} styling={"p-sm"} element={"span"} color="crystal">
              {t("Owner")}
            </TypographyComponent>
            <TypographyComponent rootClassName={styles.titleContent} styling={"p-default"} boldness={"semi"} element={"span"} color="white">
              {decodedToken.invitedBy}
            </TypographyComponent>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default ExpiredTokenComponent;
